import { IconName } from '@klp/design/Illustrations';
import { SidebarMenuItem } from '@klp/layout/Sidebar/classes/SidebarMenuItem';
import { generateRoute } from '@klpkonsern/routing';
import { getConfig, getRequiredConfig } from '@klpkonsern/appconfig';
import type { Bruker } from '@klp/user';
export const baerekraftModuleName = 'baerekraft';
export const EnvironmentModuleName = 'environment';
export const MiljoprofilModuleName = 'miljo';
const AvfallRoute = 'avfall';

export const EnvironmentRoutes = {
    moduleRoute: () =>
        generateRoute([baerekraftModuleName, EnvironmentModuleName]),
    environmentList: () =>
        generateRoute([baerekraftModuleName, EnvironmentModuleName]),
    prosjektAvfall: () => generateRoute([baerekraftModuleName, AvfallRoute]),
};

export const MiljoprofilRoutes = {
    moduleRoute: () =>
        generateRoute([baerekraftModuleName, MiljoprofilModuleName]),
    list: () => generateRoute([baerekraftModuleName, MiljoprofilModuleName]),
};

export const EnvironmentAccess = (user: Bruker | undefined): boolean =>
    Boolean(user && user.isAdmin);

export const MiljoprofilAccess = (user: Bruker | undefined): boolean =>
    Boolean(getConfig('WEBAPP_MILJOPROFIL_ENABLE') && user && user.isAdmin);

export const EnvironmentMenuItems = [
    new SidebarMenuItem({
        route: EnvironmentRoutes.environmentList(),
        matchRoute: EnvironmentRoutes.moduleRoute(),
        icon: IconName.HORIZONTAL_BAR_CHART,
        translation: 'environment.powerBi',
        access: EnvironmentAccess,
    }),
    new SidebarMenuItem({
        route: MiljoprofilRoutes.list(),
        matchRoute: MiljoprofilRoutes.moduleRoute(),
        icon: IconName.PLANT,
        translation: 'environment.miljoprofil',
        access: MiljoprofilAccess,
    }),
    new SidebarMenuItem({
        route: EnvironmentRoutes.prosjektAvfall(),
        matchRoute: EnvironmentRoutes.prosjektAvfall(),
        icon: IconName.DOCUMENTS,
        translation: 'sustainability.prosjektAvfall.title',
        access: EnvironmentAccess,
    }),
];

export const PowerBiEnvironmentalProfileURL = () =>
    getRequiredConfig('WEBAPP_POWER_BI_ENVIRONMENTAL_PROFILE_URL');

export const MiljoprofilUrl = () =>
    getRequiredConfig('WEBAPP_APP_MILJOPROFIL_LINK');

export enum localStorageReferences {
    SELECTED_PROSJEKTAVFALL_FROM_DATE = 'storedProsjektAvfallFromDate',
    SELECTED_PROSJEKTAVFALL_TO_DATE = 'storedProsjektAvfallToDate',
}
